type PillTone = "success" | "warning" | "error" | "info";

const normalizeStatus = (status?: string | null) => (status || "").trim().toLowerCase();

const toneForStatus = (status?: string | null): PillTone => {
  const normalized = normalizeStatus(status);
  if (!normalized) return "info";
  if (normalized.includes("declin") || normalized.includes("reject") || normalized.includes("cancel")) return "error";
  if (normalized.includes("credit")) return "info";
  if (normalized.includes("receiv")) return "success";
  return "warning";
};

const classNameForTone = (tone: PillTone) => {
  switch (tone) {
    case "success":
      return "border-emerald-200 bg-emerald-50 text-emerald-700";
    case "warning":
      return "border-amber-200 bg-amber-50 text-amber-800";
    case "error":
      return "border-rose-200 bg-rose-50 text-rose-700";
    case "info":
    default:
      return "border-sky-200 bg-sky-50 text-sky-700";
  }
};

interface ReturnStatusPillProps {
  status?: string | null;
}

export default function ReturnStatusPill({ status }: ReturnStatusPillProps) {
  const label = status?.trim() || "Unknown";
  const tone = toneForStatus(status);

  return (
    <span
      className={[
        "inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-wide",
        classNameForTone(tone),
      ].join(" ")}
    >
      {label}
    </span>
  );
}
